import { CWTSchemaPropertySummary, WorksheetSchemaTable } from '../../../../../types/custom-worksheet-v2';
import { sortByOrder } from '../../store/utils';
import { isNullOrUndefined } from '../../../../new-workpaper/utils';
import { FieldValue } from '../field/CWReadField';
import QuickActions from '../field/QuickActions';
import { useSelector } from 'react-redux';
import { selectShowHidden } from '../../store/selectors';
import { TableCell, TableFooter, TableRow } from '../../../../../components/data-table/DataTable';

type TableSummaryProps = {
    table: WorksheetSchemaTable;
};

function TableSummary({ table }: TableSummaryProps): JSX.Element | null {
    const showHidden = useSelector(selectShowHidden);

    return (
        <TableFooter>
            <TableRow>
                {sortByOrder(table.row.properties)
                    .filter((prop) => (prop.hidden ? showHidden : true))
                    .map((prop, idx) => {
                        const ref = prop.id.split('.').pop() as string;
                        const summary = table.summary!.properties[ref];
                        return (
                            <TableCell key={prop.id} cellIndex={idx + 1} className="align-top">
                                {summary && (
                                    <div className="py-1 px-4 flex flex-col justify-between">
                                        <p className="text-xs text-gray-600 font-medium uppercase">{prop.name} (SUM)</p>

                                        <div
                                            className={`flex items-center gap-x-1 ${
                                                (summary?.quickActions?.length ?? 0) > 0 ? '' : 'mt-2'
                                            }`}
                                            style={{ justifyContent: prop.styles.alignment }}
                                        >
                                            <QuickActions field={summary as CWTSchemaPropertySummary} actions={summary?.quickActions} />

                                            <FieldValue type={prop.type} value={isNullOrUndefined(summary?.value) ? '' : summary!.value} />
                                        </div>
                                    </div>
                                )}
                            </TableCell>
                        );
                    })}
            </TableRow>
        </TableFooter>
    );
}

export default TableSummary;
